   

<template>
    <div id='footer' class='container-fluid fedsightBlueBackground'>
        <div class='row'>
            <div class='col-lg-2 col-md-12 text-align-left pl-3'>
                <ul class='footerList  d-inline-block'>
                    <li class='fedsightYellow footerHeader'>Contact Us</li>
                    <li class='whiteText'>
                        <div class='d-flex'>
                            <div style='padding-right: 3rem;'>
                                <h4 style='margin: 0rem; padding: 0rem;'>Leesburg, VA</h4>
                                <p class='whiteText' style='min-width: 15.6rem;'>
                                    215 Depot Court SE <br>
                                    2nd Floor #249 <br>
                                    Leesburg, VA 20175
                                </p>
                            </div>
                            <!-- div>
                                <h4 style='margin: 0rem; padding: 0rem;'>Charleston, SC</h4>
                                <p class='whiteText' style='min-width: 15.6rem;'>
                                    68 Line St. <br>
                                    Suite 6 <br>
                                    Charleston, SC 29403
                                </p>
                            </div -->
                        </div>
                        
                    </li>
                    <!-- <li><strong>Phone:</strong> </li> -->
                    <li class='whiteText emailLink' @click='emailUs()' style='padding: 1rem 0rem 0.5rem;'><strong>Email:</strong> info@fedsight.com </li>
                     <li class='whiteText emailLink' style='padding-bottom: 1rem;'><strong>Phone: </strong><a href='tel:8006806982' class='whiteText emailLink'>(800) 680-6982</a></li>
                    <li class='whiteText'><a href='https://www.linkedin.com/company/fedsight-llc' target='_blank' rel="noreferrer" aria-label='Link to Fedsights LinkedIn profile' class='linkedInIcon whiteText' style='padding: 1rem 0rem;'>LinkedIn <font-awesome-icon :icon="['fab', 'linkedin-in']" /></a></li>
                    <li class='whiteText'><a href='../blog' target='_blank' aria-label='Link to Fedsights Blog' class='whiteText' style='padding: 1rem 0rem;'>Fedsight Blog <font-awesome-icon :icon="['fas', 'blog']" /></a></li>
                </ul>
            </div>
            <!-- <div class='col-6 col-md-3'>
                <ul class='footerList m-auto d-inline-block'>
                    <h3 class='fedsightGreen'>Quick Links</h3>
                    <li><router-link to="/" class='col-xs-3'>Home</router-link></li>
                    <li><router-link to="/services" class='col-xs-3'>Services</router-link></li>
                    <li><router-link to="/ourApproach" class='col-xs-3'>Our Approach</router-link></li>
                    <li><router-link to="/about" class='col-xs-3'>About Us</router-link></li>
                    <li><router-link to="/whoWeServe" class='col-xs-3'>Who We Serve</router-link></li>
                </ul>
            </div> -->
            <!-- <div class='col-xs-6 col-md-3'>
                <ul class='footerList'>
                    <h3 class='fedsightGreen'>Something Else</h3>
                    <li>Interesting Stuff</li>
                    <li>Cool Link</li>
                    <li>Brag about something</li>
                </ul>
            </div> -->
            
            <div class='footerCerts col-lg-10 col-md-12 pr-3 d-flex flex-wrap align-items-start'>
                <img class='certImg d-inline-block m-0 mr-4' style='padding-left: 1.8rem; height: 8rem;max-width: 100%;' src="@/assets/CMMI.png" alt='ISO certification logo'>
                <img class='certImg d-inline-block m-0 mr-4' style='padding-left: 1.8rem;' src="@/assets/gius_1051.jpg" alt='ISO certification logo'>
                <div class='d-flex align-items-center flex-column'>
                    <img class='certImg d-inline-block ml-0 mr-0' src='@/assets/hubzone5-3-1080x675.jpg' alt="hubzone certification logo">
                    <p class='whiteText' style='padding-top: 0.5rem;'><font-awesome-icon :icon="['fas', 'copyright']" />Fedsight Consulting</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Footer',
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#footer{
    padding: 3rem 1.5rem;
    margin-top: 8rem;
}
.footerBar{
    color: #fff;
    margin-top: 2rem;
}
.footerBar > p,
.footerBar > a{
    margin: 0rem;
    padding: 2rem;
}
.footerHeader{
    font-size: 1.75rem !important;
    font-family: 'comfortaaregular', sans-serif;
}
.certImg{
    width: auto;
    margin: auto;
    height: 8rem;
}
.footerList{
    padding: 0rem 1rem;
    text-align: left;
}
.footerList > li{
    list-style-type: none;
    font-size: 1.4rem;
    padding: 0.2rem 0rem;
}
.footerList > li > a{
    text-decoration: none;
}
.footerList > li > a:hover{
    color: #579C5F;
}
.linkedInIcon{
    padding-right: 1rem;
    color: #fff;
}
.linkedInIcon:hover{
    color: #ddd;
}
.emailLink{
    cursor: pointer;
}
.emailLink:hover{
    color: #F7D72A !important;
}
.footerCerts{
    margin-top: 2rem;
}

/* Large devices (desktops, 992px and up) */
  @media (min-width: 1240px) { 
    .footerCerts{
        justify-content: flex-end !important;
    }
    .certImg {
        height: 12.5rem;
    }
  }

  @media (max-width: 576px) { 
    .footerCerts{
        flex-direction: column;
        align-items: center !important;
    }
    .certImg {
        margin-top: 2rem !important;
    }
  }
</style>
